import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=59e983ed&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=59e983ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e983ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59e983ed')) {
      api.createRecord('59e983ed', component.options)
    } else {
      api.reload('59e983ed', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=59e983ed&scoped=true&", function () {
      api.rerender('59e983ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2beQMth7xDv32/JS/comp/PopupBox.vue"
export default component.exports